<template>
  <div class="domaine-container">

    <div class="header-container">
      <div class="header">
        <div class="navbar">
          <app-accueil-navbar @toggleMenu="toggleMenuTwo" :open="menuShowed"></app-accueil-navbar>
        </div>

        <div class="titre">
          <h1>Transports</h1>
          <img src="../../img/domaine_activite/element_graphique_domaine.svg" alt="">
        </div>

        <transition name="size-menu">
          <app-accueil-hamburger v-if="this.menuShowed"></app-accueil-hamburger>
        </transition>

        <transition name="opacity">
          <div class="shadow" v-if="this.menuShowed" @click="toggleMenuTwo"></div>
        </transition>
      </div>

    </div>

      <div class="space"></div>

      <div class="content flex-column">
          <div class="flex-column">
              <h2>Pour vous faire voyager plus loin</h2>
              <p>
                La modernisation du réseau ferré français ainsi que l’important programme de rénovation des principales gares ferroviaires française ces dernières années a été au cœur de l’engagement de CYBERDINE CONSEIL.
                <br>
                En effet à travers un partenariat de plus de 5 ans de confiance avec SNCF Réseau, nous intervenons au cœur des problématiques techniques d’évolution des infrastructures.
                <br>
                CYBERDINE CONSEIL a su se positionner comme acteur majeur sur nombre de projets de création de Pôle d’Echanges Multimodaux, sur l’arc Bretagne – Pays de la Loire principalement.
              </p>
            <div class="image-container-2 flex-row-wrap">
              <div class="photo photo-1 length-2" @click="open(1)"><div class="overlay-black"><p>Ferroviaire</p></div></div>
              <div class="photo photo-2 length-2" @click="open(2)"><div class="overlay-black"><p>Maritime</p></div></div>
              <div class="photo photo-3 length-2" @click="open(3)"><div class="overlay-black"><p>Urbain Métropolitain</p></div></div>
              <div class="photo photo-4 length-2" @click="open(4)"><div class="overlay-black"><p>Routier</p></div></div>
              <div class="photo photo-5 length-2" @click="open(5)"><div class="overlay-black"><p>Aérien</p></div></div>
              <div class="photo photo-6 length-2" @click="open(6)"><div class="overlay-black"><p>Urbain Tramway</p></div></div>
            </div>
          </div>

        <transition name="opacity">
          <div class="black-screen" v-if="imageShowed" @click="closeImage"></div>
        </transition>
        <transition name="opacity">
          <div class="image-container" v-if="imageShowed">
            <div @click="closeImage">
              <div class="arrow-container left flex-column" @click.stop="prevImage" v-if="!changingImage">
                <img src="../../img/slider_accueil/fleche.svg" class="arrow" alt="">
              </div>
              <transition name="opacity-speed" mode="out-in">
                <img v-for="(image, index) in images" :src="image.imageName" v-if="image.active" :key="index" class="length-1" alt="" @click.stop="">
              </transition>
              <div class="arrow-container right flex-column" @click.stop="nextImage" v-if="!changingImage">
                <img src="../../img/slider_accueil/fleche.svg" class="arrow" alt="">
              </div>
            </div>
          </div>
        </transition>

          <div class="buttons-container flex-row-space-between">
              <div class="left" @click="changeTo('domaine')">
                  <img src="../../img/domaine_activite/fleche_domaine_dactivite.svg" alt="">
                  <p>Télécommunications</p>
              </div>
              <div class="center" @click="changeTo('accueil')">
                  <img src="../../img/domaine_activite/petite_maison.svg" alt="">
              </div>
              <div class="right" @click="changeTo('domaine-cfcf')">
                  <p>Courant Fort / Courant Faible</p>
                  <img src="../../img/domaine_activite/fleche_domaine_dactivite.svg" alt="">
              </div>
          </div>
      </div>

      <div class="contact-container flex-column">
          <div class="contact flex-row-space-between-wrap">
              <div class="contact-content">
                  <h3>Cyberdine Conseil</h3>
                  <div class="infos">
                      <img src="../../img/domaine_activite/adresse_domaine_dactivite.svg" alt="">
                      <p>Rue de l'Indre - Quartier EURONANTES - 44000 NANTES</p>
                  </div>
                  <div class="infos">
                      <img src="../../img/domaine_activite/enveloppe_domaine_dactivite.svg" alt="">
                      <p>contact@cyberdineconseil.fr</p>
                  </div>
              </div>

              <button @click="changeTo('contact')">Contact</button>
          </div>
      </div>

    <app-contact></app-contact>

    <app-footer></app-footer>
  </div>
</template>

<script>
    import {menuBus} from "../../main";

    import Navbar from "./Navbar";
    import Footer from "../Footer";
    import HamburgerMenu from "../accueil/HamburgerMenu";
    import Contact from "../accueil/Contact";

    import image1 from "../../img/domaine_activite/Ferroviaire.jpg";
    import image2 from "../../img/domaine_activite/Maritime.jpg";
    import image3 from "../../img/domaine_activite/Urbain_Metropolitain.jpg";
    import image4 from "../../img/domaine_activite/Routier.jpg";
    import image5 from "../../img/domaine_activite/Aerien.jpg";
    import image6 from "../../img/domaine_activite/Urbain_Tramway.jpg";

  export default {
      data() {
          return {
              menuShowed: false,
              imageShowed: false,
              changingImage: false,
              images: [
                  {
                      imageName: image1,
                      active: false,
                  },
                  {
                      imageName: image2,
                      active: false,
                  },
                  {
                      imageName: image3,
                      active: false,
                  },
                  {
                      imageName: image4,
                      active: false,
                  },
                  {
                      imageName: image5,
                      active: false,
                  },
                  {
                      imageName: image6,
                      active: false,
                  },
              ]
          }
      },
      methods: {
          toggleMenuTwo() {
              this.menuShowed = !this.menuShowed;
              if (this.menuShowed) {
                  document.getElementsByTagName('body')[0].classList.add('blocked');
              }
              else {
                  document.getElementsByTagName('body')[0].classList.remove('blocked');
              }
          },
          changeTo(pageName) {
              menuBus.$emit('changePage', pageName);
          },
          open(imageId) {
              this.unactiveAll();
              this.images[imageId-1].active = true;
              this.imageShowed = true;
              this.changingImage = false;
          },
          closeImage() {
              this.imageShowed = false;
              this.unactiveAll();
          },
          unactiveAll() {
              for (let i=0; i < this.images.length; i++) {
                  this.images[i].active = false;
              }
          },
          imageActiveIndex() {
              for (let i=0; i < this.images.length; i++) if (this.images[i].active == true) return i;
          },
          nextImage() {
              this.changingImage = true;
              if (this.imageActiveIndex()+1 == this.images.length) this.open(1);
              else this.open(this.imageActiveIndex()+2);
          },
          prevImage() {
              this.changingImage = true;
              if (this.imageActiveIndex() == 0) this.open(this.images.length-1);
              else this.open(this.imageActiveIndex());
          }
      },
      mounted() {
          menuBus.$on('changePage', (pageName, idName) => {
              this.menuShowed = false;
          });
      },
    components: {
        'app-accueil-navbar': Navbar,
        'app-footer': Footer,
        'app-contact': Contact,
        'app-accueil-hamburger': HamburgerMenu,
    }
  }
</script>

<style scoped>
  .header-container {
    z-index: 100;
  }

  .header {
    position: relative;
    height: 170px;
  }
  .navbar {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 100;
  }

  .image-container-2 {
    width: 90%;
  }
  .image-container-2 .photo {
    height: 400px;
    margin: 10px;
    background-size: cover;
    cursor: pointer;
  }
  .image-container-2 .length-2 {
    width: calc(50% - 20px);
    min-width: 620px;
  }

  .photo-1 {
    background: url("../../img/domaine_activite/reduct/reduct_Ferroviaire.jpg") no-repeat center center;
  }
  .photo-2 {
    background: url("../../img/domaine_activite/reduct/reduct_Maritime.jpg") no-repeat center center;
  }
  .photo-3 {
    background: url("../../img/domaine_activite/reduct/reduct_Urbain_Metropolitain.jpg") no-repeat center center;
  }
  .photo-4 {
    background: url("../../img/domaine_activite/reduct/reduct_Routier.jpg") no-repeat center center;
  }
  .photo-5 {
    background: url("../../img/domaine_activite/reduct/reduct_Aerien.jpg") no-repeat center center;
  }
  .photo-6 {
    background: url("../../img/domaine_activite/reduct/reduct_Urbain_Tramway.jpg") no-repeat center center;
  }

  .photo .overlay-black {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);

    display: flex;
    align-items: center;
    justify-content: center;

    opacity: 0;
  }
  .overlay-black p {
    text-align: center!important;
    margin: 0!important;
    color: white!important;
    font-size: 25px!important;
    font-weight: normal!important;
  }
  .photo:hover .overlay-black {
    opacity: 1;
  }

  @media (max-width: 1430px) {
    .length-2 {
      width: calc(100% - 10px) !important;
      min-width: 0 !important;
    }
  }

  .titre {
    height: 450px;
    width: 100%;
    background-color: #162139;

    position: absolute;
    top: 0;
    z-index: 50;
  }
  .titre h1 {
    position: absolute;
    left: 100px;
    top: calc(50% + 20px);
    transform: translateY(-50%);

    z-index: 10;

    font-size: 60px;
    color: white;
    font-weight: bolder;
  }
  .titre img {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 330px;
  }

  .space {
    height: 280px;
  }

  .content {
    width: 100%;
    height: fit-content;
  }
  .content > div {
    min-width: calc(100% - 200px);
    width: 90%;
    max-width: calc(100% - 50px);
  }
  .content h2 {
    font-weight: 900;
    color: #162139;
    font-size: 60px;
    margin: 100px 0;
    width: 100%;
    text-align: left;
  }
  .content p {
    width: 100%;
    font-size: 20px;
    color: #969fb4;
    font-weight: 300;
    text-align: left;
    margin-bottom: 70px;
    margin-top: 0;
    line-height: 1.5;
  }

  .image-container-2 {
    width: 100%;
  }
  .image-container-2 img {
    width: 100%;
    margin: 30px 0;
  }

  .buttons-container {
    height: 150px;
    width: 100%;

    position: relative;

    margin-bottom: 30px;
  }
  .buttons-container > div {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .buttons-container .left, .buttons-container .right {
    height: 30px;
  }
  .buttons-container .center {
    height: 55px;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }
  .buttons-container .right img {
    transform: rotate(180deg);
  }
  .buttons-container img {
    height: 100%;
  }
  .buttons-container p {
    margin: 0 10px;
    color: #584d70;
    font-size: 20px;
    font-weight: 900;
  }

  .contact-container {
    background-color: #f1f2f6;
    width: 100%;
    padding: 100px 0;
  }
  .contact {
    min-width: calc(100% - 200px);
    width: 90%;
    max-width: calc(100% - 50px);
  }
  .contact img {
    height: 55px;
    margin-right: 30px;
  }
  .contact .infos {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    max-width: 100%;
  }
  .contact-content {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    max-width: 100%;
  }
  .contact-content > div {
    margin: 10px 0;
  }
  .contact h3 {
    font-size: 30px;
    text-transform: uppercase;
    color: #162139;
    font-weight: 900;
    margin-bottom: 10px;
    text-align: left;
  }
  .contact p {
    color: #162139;
    text-align: left;
    font-size: 20px;
    margin: 0;
    overflow-wrap: anywhere;
  }
  .contact button {
    color: white;
    padding: 20px 50px;
    background-color: #584d70;
    border: 3px solid rgba(88, 77, 112, 0);
    text-transform: uppercase;
    font-size: 25px;
    margin-top: 50px;
    margin-bottom: 50px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .contact button:hover {
    border: 3px solid #584d70;
    color: #584d70;
    background: none;
  }

  .black-screen {
    height: 100%!important;
    width: 100%!important;
    max-width: initial!important;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 200;
    position: fixed;
    top: 0;
    left: 0;
  }
  .image-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 200;

    max-height: 95vh;
    max-width: 90vw;
  }
  .image-container > div {
    position: relative;
  }
  .image-container img {
    max-width: 100%;
    max-height: 90vh;
  }
  .image-container .arrow-container {
    position: absolute;
    height: 100%;
    width: 50px;
    z-index: 10;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;

    opacity: 1;
    transition: opacity 0.2s;
  }
  .image-container .arrow-container.left {
    left: 0;
    align-items: flex-start;
    padding-left: 5px;
    background: rgba(0, 0, 0, 0);
  }
  .image-container .arrow-container.left:hover {
    opacity: 1;
  }
  .image-container .arrow-container.right {
    right: 0;
    align-items: flex-end;
    padding-right: 5px;
    background: rgba(0, 0, 0, 0);
  }
  .image-container .arrow-container.right:hover {
    opacity: 1;
  }

  .image-container .arrow-container .arrow {
    height: 30px;
  }
  .image-container .arrow-container.right .arrow {
    transform: rotate(180deg);
  }

  @media (max-width: 1200px) {
    .titre img {
      display: none;
    }
  }

  /* Mobile */
  @media (max-width: 700px) {
    .image-container-2 img {
      margin: 10px 0;
    }
    h2 {
      margin: 50px 0!important;
    }
    .titre {
      display: none!important;
    }
    .space {
      height: 30px;
    }
  }
  @media (max-width: 550px) {
    .buttons-container p {
      display: none;
    }
    h2 {
      font-size: 40px!important;
    }
    button {
      width: 100%;
      padding: 20px 0!important;
    }
    .contact-container {
      padding: 50px 0;
    }
  }
  @media (max-width: 400px) {
  }

  .size-menu-enter-active,
  .size-menu-leave-active {
    transition: all 0.5s;
    max-height: 500px!important;
  }
  .size-menu-enter,
  .size-menu-leave-to
  {
    opacity: 0;
    max-height: 0px!important;
  }

  .shadow {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 60;
    position: fixed;
  }

  .opacity-enter-active,
  .opacity-leave-active {
    transition: all 0.5s;
  }
  .opacity-enter,
  .opacity-leave-to
  {
    opacity: 0;
  }

  @media (min-width: 1100px) {
    .shadow {
      display: none!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/domaine/DomaineTransport.vue